import { useGetGlAccounts } from '@/shared/api/client/coa-resource';
import {useGetConfigurations, useUpdateConfigurationAccount} from "@/shared/api/client/payment-configurations";

export function usePaymentConfigurations() {
    return useGetConfigurations();
}

export function useUpdatePaymentConfiguration() {
    return useUpdateConfigurationAccount({
        mutation: {
            onError: (error) => {
                console.error('Failed to update configuration:', error);
            }
        }
    });
}

export function useGlAccountsByType(acType: string) {
    // @ts-ignore
    return useGetGlAccounts('AC', {q:"", acType:acType });
}